<template>
  <div>
    <div
      v-if="aberto"
      class="modal-backdrop fade show"
      @click="fechar"
    ></div>

    <div
      v-if="instanciavel"
      class="modal fade modal-sncr"
      :class="{ show: aberto }"
      :style="{ display: aberto ? 'block' : 'none' }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="sncrModalTitulo"
      aria-modal="true"
      @keydown.esc="fechar"
    >
      <div class="modal-dialog modal-sncr-dialog" role="document">
        <div class="modal-content modal-sncr-content">

          <div class="modal-header border-bottom py-2 px-3">
            <SNCRHeaderModal
              @fechar="fechar"
            />
          </div>

          <div class="modal-body modal-sncr-body" aria-live="polite">

            <div
              v-if="carregando"
              class="d-flex flex-column align-items-center justify-content-center h-100"
            >
              <div class="spinner-border text-primary mb-3" role="status">
                <span class="sr-only">Carregando numerações…</span>
              </div>
              <p class="text-muted mb-0">Buscando numerações disponíveis…</p>
            </div>

            <div v-else class="sncr-layout">

              <section class="sncr-secao">
                <div class="d-flex align-items-baseline mb-1">
                  <i class="fas fa-pills mr-2 text-primary" aria-hidden="true"></i>
                  <h6 class="font-weight-bold mb-0">Receitas de Notificação</h6>
                </div>
                <p class="text-muted small mb-2">
                  Lotes de {{ LIMITE_MAXIMO_DIARIO }} numerações &middot; Validade diária
                </p>

                <div class="row no-gutters sncr-row">
                  <div
                    v-for="tipo in lotesDiarios"
                    :key="tipo.sigla"
                    class="col-12 col-sm-6 col-lg-4 col-xl px-1 mb-2"
                  >
                    <div class="card h-100 shadow-sm" :style="cardStyle(tipo.lote.in_total_nums_disponiveis)">
                      <div class="card-body d-flex flex-column py-2 px-2">

                        <div class="d-flex justify-content-between align-items-start mb-1">
                          <span
                            class="badge badge-pill"
                            :class="badgeClass(tipo.lote.in_total_nums_disponiveis)"
                            style="font-size: 0.7rem; padding: 0.3em 0.65em;"
                          >{{ tipo.sigla }}</span>
                          <span
                            class="font-weight-bold sncr-count"
                            :style="{ color: corStatus(tipo.lote.in_total_nums_disponiveis) }"
                            :title="tipo.lote.in_total_nums_disponiveis + ' numerações disponíveis'"
                          >{{ tipo.lote.in_total_nums_disponiveis }}</span>
                        </div>

                        <h6 class="card-title mb-1 sncr-card-title">
                          {{ tipo.nome }}
                        </h6>
                        <p class="card-text text-muted sncr-card-desc">
                          {{ tipo.descricao }}
                        </p>

                        <SNCRProgressBar
                          label-header="Limite máximo diário"
                          :value-limite="LIMITE_MAXIMO_DIARIO"
                          :value-usado="tipo.lote.in_total_nums_lote"
                          label-footer="para hoje."
                        >
                        </SNCRProgressBar>

                        <div class="mt-auto">
                          <p class="small text-muted mb-1">
                            <i class="far fa-clock mr-1" aria-hidden="true"></i>
                            <template v-if="tipo.lote.dt_expiracao">
                              Expira em {{ formatarExpiracao(tipo.lote.dt_expiracao) }}
                            </template>
                            <template v-else>
                              Sem lote ativo no momento
                            </template>
                          </p>
                          <SNCRSolicitarLoteButton
                            :ref="'solicitar-' + tipo.sigla"
                            :tipo="tipo"
                            @sucesso="onSucessoLote"
                            @nao-autorizado="conectarSNCR"
                            @iniciar-solicitacao="onIniciarSolicitacao"
                          />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section class="sncr-secao">
                <div class="d-flex align-items-baseline mb-1">
                  <i class="fas fa-file-medical mr-2 text-primary" aria-hidden="true"></i>
                  <h6 class="font-weight-bold mb-0">Receitas Especiais</h6>
                </div>
                <p class="text-muted small mb-2">
                  Lotes de 3.000 numerações &middot; Validade mensal &middot; Limite compartilhado de 3.000 por mês
                </p>

                <div class="row no-gutters sncr-row">
                  <div
                    v-for="tipo in lotesMensais"
                    :key="tipo.sigla"
                    class="col-12 col-sm-6 col-md-4 px-1 mb-2"
                  >
                    <div class="card shadow-sm" :style="cardStyle(tipo.lote.in_total_nums_disponiveis)">
                      <div class="card-body d-flex flex-column py-2 px-2">

                        <div class="d-flex justify-content-between align-items-start mb-1">
                          <span
                            class="badge badge-pill"
                            :class="badgeClass(tipo.lote.in_total_nums_disponiveis)"
                            style="font-size: 0.7rem; padding: 0.3em 0.65em;"
                          >{{ tipo.sigla }}</span>
                          <span
                            class="font-weight-bold sncr-count"
                            :style="{ color: corStatus(tipo.lote.in_total_nums_disponiveis) }"
                            :title="tipo.lote.in_total_nums_disponiveis + ' numerações disponíveis'"
                          >{{ tipo.lote.in_total_nums_disponiveis }}</span>
                        </div>

                        <h6 class="card-title mb-1 sncr-card-title">
                          {{ tipo.nome }}
                        </h6>
                        <p class="card-text text-muted sncr-card-desc">
                          {{ tipo.descricao }}
                        </p>

                        <SNCRProgressBar
                          label-header="Limite máximo mensal"
                          :value-limite="LIMITE_MAXIMO_MENSAL"
                          :value-usado="tipo.lote.in_total_nums_lote"
                          label-footer="para este mês."
                        >
                        </SNCRProgressBar>
                        <div class="mt-auto">
                          <p class="small text-muted mb-1">
                            <i class="far fa-clock mr-1" aria-hidden="true"></i>
                            <template v-if="tipo.lote.dt_expiracao">
                              Expira em {{ formatarExpiracao(tipo.lote.dt_expiracao) }}
                            </template>
                            <template v-else>
                              Sem lote ativo no momento
                            </template>
                          </p>
                          <SNCRSolicitarLoteButton
                            :ref="'solicitar-' + tipo.sigla"
                            :tipo="tipo"
                            @sucesso="onSucessoLote"
                            @nao-autorizado="conectarSNCR"
                            @iniciar-solicitacao="onIniciarSolicitacao"
                          />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </section>

            </div>
          </div>

          <div class="modal-footer border-top py-2 px-3">
            <button
              type="button"
              class="btn btn-secondary"
              @click="fechar"
            >
              Fechar
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-sncr {
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1070;
}

.modal-backdrop {
  z-index: 1065;
}

.modal-sncr-dialog {
  margin: 0;
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
}

.modal-sncr-content {
  height: 100%;
  max-height: 100%;
  border-radius: 0;
  border: none;
  box-shadow: none;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  flex-shrink: 0;
}

.modal-sncr-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 0.75rem 1rem;
}

.sncr-layout {
  display: flex;
  flex-direction: column;
  min-height: 0;
  gap: 0.75rem;
}

.sncr-secao {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  min-height: 0;
}

.sncr-count {
  font-size: 1.25rem;
  line-height: 1;
}

.sncr-card-title {
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.3;
}

.sncr-card-desc {
  font-size: 0.7rem;
  line-height: 1.35;
  margin-bottom: 0.4rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>

<script>
import SNCRProgressBar from "./SNCRProgressBar.vue";
import SNCRSolicitarLoteButton from "./SNCRSolicitarLoteButton.vue";
import {
  SNCR_CATEGORIAS,
  SNCR_LIMITE_MAXIMO_DIARIO,
  SNCR_LIMITE_MAXIMO_MENSAL,
  SNCR_LOTE_TEMPLATE,
  SNCR_TIPOS
} from "./sncr.const";
import SNCRHeaderModal from "./SNCRHeaderModal.vue";

export default {
  name: 'SNCRNumeracoesModal',
  components: {SNCRHeaderModal, SNCRProgressBar, SNCRSolicitarLoteButton},

  data() {
    return {
      LIMITE_MAXIMO_DIARIO: SNCR_LIMITE_MAXIMO_DIARIO,
      LIMITE_MAXIMO_MENSAL: SNCR_LIMITE_MAXIMO_MENSAL,
      TIPOS: SNCR_TIPOS,
      categorias: SNCR_CATEGORIAS,
      lote_template: SNCR_LOTE_TEMPLATE,
      state: null,
      instanciavel: false,
      aberto: false,
      carregando: false,
      requisicaoPendente: null,
      sncrPopup: null,
      sncrTimer: null,
      numeracoes: [],
      jaReautenticou: false,
      reauthEmAndamento: false,
      authMessageHandled: false,
    };
  },

  computed: {
    mapaPorTipo() {
      return Object.fromEntries(
        this.numeracoes.map(n => [n.st_tipo_receita, n])
      );
    },
    tiposComLote() {
      return this.TIPOS.map(tipo => ({
        ...tipo,
        lote: this.mapaPorTipo[tipo.sigla] !== undefined ? this.mapaPorTipo[tipo.sigla] : {
          ...this.lote_template,
          st_tipo_receita: tipo.sigla, 
        },
      }));
    },
    lotesDiarios() {
      return this.tiposComLote.filter(t => t.categoria === this.categorias.DIARIO);
    },
    lotesMensais() {
      return this.tiposComLote.filter(t => t.categoria === this.categorias.MENSAL);
    },
  },

  mounted() {
    window.addEventListener('message', this.ouvirRetornoGov);
  },

  beforeDestroy() {
    document.body.classList.remove('modal-open');
    window.removeEventListener('message', this.ouvirRetornoGov);
    document.documentElement.classList.remove('overflow-hidden');
    this.limparMonitorPopup();
  },
  
  methods: {
    abrir() {
      document.documentElement.classList.add('overflow-hidden');
      this.resetarCicloAuth();
      this.instanciavel = true;
      this.$nextTick(() => {
        this.aberto = true;
        document.body.classList.add('modal-open');
        const dialog = this.$el.querySelector('[role="dialog"]');
        if (dialog) dialog.focus();
      });
      this.buscarNumeracoes();
    },

    resetarCicloAuth() {
      this.jaReautenticou = false;
      this.reauthEmAndamento = false;
      this.authMessageHandled = false;
    },

    onIniciarSolicitacao() {
      this.resetarCicloAuth();
    },

    fechar() {
      this.aberto = false;
      document.body.classList.remove('modal-open');
      document.documentElement.classList.remove('overflow-hidden');
    },

    botaoPorSigla(sigla) {
      const ref = this.$refs['solicitar-' + sigla];
      return Array.isArray(ref) ? ref[0] : ref;
    },

    onSucessoLote() {
      this.resetarCicloAuth();
      this.buscarNumeracoes();
    },

    buscarNumeracoes(opcoes) {
      const retrySigla = opcoes && opcoes.retrySigla ? opcoes.retrySigla : null;
      this.carregando = true;

      this.$util.atualizar(this, {
        service: 'sncr',
        dados: {
          id_medico: this.$store.state.user.id_pessoa,
        },
        func: 'listar_numeracoes_receita',
        callback: response => {
          this.numeracoes = response.data || [];
        },
        final: () => {
          this.carregando = false;
          if (retrySigla) {
            this.$nextTick(() => {
              const botao = this.botaoPorSigla(retrySigla);
              if (botao) botao.solicitar();
            });
          }
        }
      });
    },

    conectarSNCR(tipoTentado = null) {
      if (this.reauthEmAndamento) return;

      if (this.jaReautenticou) {
        this.$toast.add({
          severity: 'error',
          summary: 'Falha na autenticação SNCR',
          detail: 'Não foi possível validar o token após o login. Tente novamente.',
          life: 4000,
        });
        return;
      }

      if (tipoTentado) {
        this.requisicaoPendente = tipoTentado;
      }

      this.reauthEmAndamento = true;

      const largura = 650;
      const altura = 750;
      const esquerda = (window.screen.width / 2) - (largura / 2);
      const topo = (window.screen.height / 2) - (altura / 2);

      const popup = window.open(
        'about:blank',
        'SNCRGovAuth',
        `width=${largura},height=${altura},top=${topo},left=${esquerda},status=no,toolbar=no,menubar=no,location=no,resizable=yes,scrollbars=yes`
      );

      if (!popup) {
        this.reauthEmAndamento = false;
        alert('Por favor, permita pop-ups neste site para continuar a autenticação no gov.br.');
        return;
      }

      this.sncrPopup = popup;
      this.iniciarMonitorPopup();

      this.$util.atualizar(this, {
        service: 'sncr',
        func: 'gerar_state',
        callback: response => {
          this.sncrPopup.location.href = response.data.url;
        },
        callback_error: () => {
          if (this.sncrPopup) this.sncrPopup.close();
          this.limparMonitorPopup();
          this.reauthEmAndamento = false;
        }
      });
    },

    ouvirRetornoGov(event) {
      if (!event.data || event.data.status !== 'sncr_auth_success') return;
      if (this.authMessageHandled) return;

      this.authMessageHandled = true;
      this.reauthEmAndamento = false;
      this.jaReautenticou = true;
      this.limparMonitorPopup();
      if (this.sncrPopup && !this.sncrPopup.closed) {
        this.sncrPopup.close();
      }

      const pendente = this.requisicaoPendente;
      this.requisicaoPendente = null;
      this.buscarNumeracoes({
        retrySigla: pendente ? pendente.sigla : null,
      });
    },

    iniciarMonitorPopup() {
      this.limparMonitorPopup();
      this.sncrTimer = setInterval(() => {
        if (!this.sncrPopup || this.sncrPopup.closed) {
          this.limparMonitorPopup();
          this.requisicaoPendente = null;
          this.reauthEmAndamento = false;
        }
      }, 1000);
    },

    limparMonitorPopup() {
      if (this.sncrTimer) {
        clearInterval(this.sncrTimer);
        this.sncrTimer = null;
      }
    },

    corStatus(disponivel) {
      if (disponivel === 0 || disponivel === undefined) return '#dc3545';
      if (disponivel <= 4) return '#ffc107';
      return '#28a745';
    },

    badgeClass(disponivel) {
      if (disponivel === 0 || disponivel === undefined) return 'badge-danger';
      if (disponivel <= 4) return 'badge-warning';
      return 'badge-success';
    },

    cardStyle(disponivel) {
      return {
        border: '1px solid rgba(0,0,0,.08)',
        borderLeft: '4px solid ' + this.corStatus(disponivel),
      };
    },

    formatarExpiracao(dt) {
      if (!dt) return '-';
      try {
        return new Date(dt).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
      } catch (_) {
        return dt;
      }
    },
  },
};
</script>